import { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { CustomChip } from "../../../../../components/chip/Chip";
import { RenderInputByTypeMobile } from "../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { Matriculas } from './Matriculas';

export const Puntaje = ({
    datosSeleccionFormData,
    resultadosSeleccion,
    handleChange,
    handlePreview,
    handleChangeArchivo,
    handleDelete,
    allowedWrite,
    isNew,
    idTipoProfesional
}) => {
    const [estadosChip] = useState({
        'Aprobado': { isGreen: true },
        'Aprobado Condicional': { isYellow: true },
        'Rechazado': { isRed: true }
    });

    useEffect(() => {
        handleChange('tituloHabilitanteCheck', datosSeleccionFormData?.tituloHabilitante?.length > 0);
    }, [datosSeleccionFormData?.tituloHabilitante]);


    const updatedFields = useMemo(() => {
        return (structuredClone(fields)
            .map(input => {
                const updatedInput = { ...input };
                switch (input.name) {
                    case 'idTipoProfesional':
                        updatedInput.disabled = !isNew;
                        break;
                    default:
                        break;
                }
                if (!allowedWrite) {
                    updatedInput.disabled = true;
                }
                return updatedInput;
            }))
    }, [isNew, allowedWrite]);

    const getEstado = (idEstado) => {
        const estadoName = !resultadosSeleccion ? 'Rechazado' : resultadosSeleccion?.find(x => x.id === idEstado)?.displayName;
        const color = estadosChip[estadoName];

        return (
            <CustomChip
                label={estadoName}
                {...color}
                sx={{ height: '26px' }}
            />
        );
    };

    return (
        <div className='generic-tab-container container-separate'>
            <Grid container spacing={2}>
                {updatedFields
                    .map((input, index) => (
                        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
                            {
                                !!input.title
                                    ?
                                    <div className='generic-header-tab-content-with-buttons'>
                                        <strong>{input.title}</strong>
                                    </div>
                                    :
                                    !!input.subtitle
                                        ?
                                        <strong>{input.subtitle}</strong>
                                        :
                                        input.name === 'idResultadoSeleccion' && (
                                            <RenderInputByTypeMobile
                                                key={`input-${input.name}-index-${index}`}
                                                input={input}
                                                handleChange={handleChange}
                                                value={getEstado(datosSeleccionFormData[input.name])}
                                            />)
                            }
                            {input.name === 'matriculas' &&
                                <Matriculas
                                    datosSeleccionFormData={datosSeleccionFormData}
                                    allowedWrite={allowedWrite}
                                    handleChange={handleChange}
                                    idTipoProfesional={idTipoProfesional}
                                />
                            }
                            {input.name !== 'idResultadoSeleccion' &&
                                input.name !== 'matriculas' && (
                                    <RenderInputByTypeMobile
                                        key={`input-${input.name}-index-${index}`}
                                        input={input}
                                        handleChange={input.type === 'file' ? handleChangeArchivo : handleChange}
                                        handleDelete={input.type === 'file' ? handleDelete : null}
                                        value={datosSeleccionFormData[input.name]}
                                    />)}
                        </Grid>
                    ))
                }
            </Grid>
        </div>
    );
}

const fields = [
    {
        subtitle: 'Titulo',
        name: 'titulo',
        col: 12
    },
    {
        displayName: 'Titulo habilitante',
        name: 'tituloHabilitanteCheck',
        type: 'custom_switch',
        disabled: true,
        col: 4
    },
    {
        displayName: 'Adjuntar titulo',
        name: 'tituloHabilitante',
        type: 'file',
        disabled: false,
        col: 6
    },
    {
        name: 'item',
        type: 'item',
        col: 2.5
    },
    {
        name: 'matriculas',
        col: 12,
        displayName: '',
    }
];